// Texto de interfaz propio de T9 (centro legal). La SUSTANCIA legal vive en content/legal/** y no se reescribe;
// aquí solo hay rótulos, el aviso del índice (textual, SPEC §9.7 · B20) y los nombres de los controles.
export type LegalLang = "es" | "en";

/** Preferencia de idioma del centro legal: solo de la sesión (sessionStorage, con try/catch). */
export const LEGAL_LANG_KEY = "dd:legal-lang";

export const LEGAL_LANG_LABEL: Record<LegalLang, string> = { es: "Español", en: "English" };

export const LEGAL_COPY: Record<
  LegalLang,
  {
    indexTitle: string;
    /** Aviso del índice. Textual: no se parafrasea. */
    notice: string;
    langGroup: string;
    updated: string;
    internal: string;
    toc: string;
    crumb: string;
    index: string;
    twin: string;
    taskTodo: string;
    taskDone: string;
    tableLabel: string;
  }
> = {
  es: {
    indexTitle: "Centro legal",
    notice:
      "Borradores estructurados. Las variables del propietario y la revisión legal deben completarse antes de tratarlos como definitivos o vinculantes. Nada aquí es asesoría legal.",
    langGroup: "Idioma de los documentos",
    updated: "Última actualización",
    internal: "Solo uso interno",
    toc: "En este documento",
    crumb: "Ruta del documento",
    index: "Centro legal",
    twin: "Read this document in English",
    taskTodo: "Pendiente",
    taskDone: "Hecho",
    tableLabel: "Tabla desplazable",
  },
  en: {
    indexTitle: "Legal center",
    notice:
      "Structured drafts. The owner's variables and legal review must be completed before treating them as final or binding. Nothing here is legal advice.",
    langGroup: "Document language",
    updated: "Last updated",
    internal: "Internal use only",
    toc: "On this page",
    crumb: "Document path",
    index: "Legal center",
    twin: "Leer este documento en español",
    taskTodo: "To do",
    taskDone: "Done",
    tableLabel: "Scrollable table",
  },
};
